/* esm.sh - es-toolkit@1.52.0/dist/object/cloneDeep */
import{cloneDeepWithImpl as o}from"es-toolkit/dist/object/cloneDeepWith";function p(e){return o(e,void 0,e,new Map,void 0)}export{p as cloneDeep};
//# sourceMappingURL=cloneDeep.mjs.map